import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const getEnvironmentalDashboard = () =>
  axios.get(`${API_URL}/environmental/dashboard`, { headers: authHeaders() });

export const getEnvironmentalSensors = () =>
  axios.get(`${API_URL}/environmental/sensors`, { headers: authHeaders() });

export const getEnvironmentalAlertUsers = () =>
  axios.get(`${API_URL}/environmental/alert-users`, { headers: authHeaders() });

export const createEnvironmentalSensor = (payload) =>
  axios.post(`${API_URL}/environmental/sensors`, payload, {
    headers: authHeaders(),
  });

export const updateEnvironmentalSensor = (sensorId, payload) =>
  axios.patch(`${API_URL}/environmental/sensors/${sensorId}`, payload, {
    headers: authHeaders(),
  });

export const deleteEnvironmentalSensor = (sensorId, confirmationWord) =>
  axios.delete(`${API_URL}/environmental/sensors/${sensorId}`, {
    headers: authHeaders(),
    data: { confirmationWord },
  });

export const getEnvironmentalHistory = (params) =>
  axios.get(`${API_URL}/environmental/history`, {
    headers: authHeaders(),
    params,
  });

export const pollEnvironmentalSensor = (sensorId) =>
  axios.post(
    `${API_URL}/environmental/sensors/${sensorId}/poll`,
    {},
    { headers: authHeaders() },
  );

export const getTuyaCredentials = () =>
  axios.get(`${API_URL}/environmental/tuya/credentials`, {
    headers: authHeaders(),
  });

export const saveTuyaCredentials = (payload) =>
  axios.post(`${API_URL}/environmental/tuya/credentials`, payload, {
    headers: authHeaders(),
  });

export const deleteTuyaCredentials = () =>
  axios.delete(`${API_URL}/environmental/tuya/credentials`, {
    headers: authHeaders(),
  });

export const getClientes = () =>
  axios.get(`${API_URL}/clientes`, {
    headers: authHeaders(),
  });

export const getSedesByCliente = (clienteId) =>
  axios.get(`${API_URL}/sedes/${clienteId}`, {
    headers: authHeaders(),
  });

export const getAreas = () =>
  axios.get(`${API_URL}/areas`, {
    headers: authHeaders(),
  });

export const getEquiposByFilters = (params) =>
  axios.get(`${API_URL}/equipos`, {
    headers: authHeaders(),
    params,
  });
